export default "__VITE_ASSET__9d6d74fd__"